import React, { Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'
import Modal from 'react-modal'
import { MdClose } from 'react-icons/md'
import { popupMiddleCenterStyles, popupTopCenterStyles } from './Style'

export type PopupProps = {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  children: React.ReactChild
  isTopCenter?: boolean
}

function Popup(props: PopupProps) {
  return (
    <Modal
      isOpen={props.open}
      preventScroll={true}
      style={props.isTopCenter ? popupTopCenterStyles : popupMiddleCenterStyles}
      ariaHideApp={false}
      onAfterOpen={() => {
        document.body.style.overflow = 'hidden'
        document.body.style.marginRight = '18px'
      }}
      onAfterClose={() => {
        document.body.style.overflow = 'unset'
        document.body.style.marginRight = '0px'
      }}
      onRequestClose={() => props.setOpen(false)}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
    >
      <Container>
        <CloseButton onClick={() => props.setOpen(false)}>
          <MdClose />
        </CloseButton>
        <>{props.children}</>
      </Container>
    </Modal>
  )
}

const Container = styled.div`
  padding: 1.5rem;

  @media (max-width: 768px) {
    padding: 0;
    box-sizing: border-box;
  }
`

const CloseButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 1.5rem;
`
export default Popup
